const ImageViewer = {
  scaleUp: 'IMAGE_VIEWER_SCALE_UP',
  scaleDown: 'IMAGE_VIEWER_SCALE_DOWN',
  scaleInit: 'IMAGE_VIEWER_SCALE_INIT',
}

const Banner = {
  onExpired: 'BANNER_ON_EXPIRED',
}

const LessonStudentGroupAccordion = {
  turnOnFloating: 'LESSON_STUDENT_GROUP_ACCORDION_TURN_ON_FLOATING',
  turnOffFloating: 'LESSON_STUDENT_GROUP_ACCORDION_TURN_OFF_FLOATING',
}

const IFrame = {
  logOutStudentApp: 'IFRAME_LOG_OUT_STUDENT_APP',
}

const PODMallParentPaymentInfoModal = {
  selectStudent: 'PODMALL_PARENT_PAYMENT_INFO_MODAL_SELECT_STUDENT',
}

export const CustomEventName = {
  ImageViewer,
  IFrame,
  Banner,
  LessonStudentGroupAccordion,
  PODMallParentPaymentInfoModal,
}
